<template>
    <UniversalPopup ref="universalPopupRef" @onConfirm="handleConfirm" />
    <div class="layout-operate-record" :class="{ 'desktop-layout-operate-record': isDesktop, 'mobile-layout-operate-record': !isDesktop }" @click="closeDrawer">
        <el-drawer :class="{ 'desktop-el-drawer': isDesktop, 'mobile-el-drawer-operate-record': !isDesktop }" v-model="drawer" :direction="direction" :before-close="handleClose" :size="drawerSize"
			:lock-scroll="true" :modal="false" :close-on-click-modal="true" :show-close="true" :with-header="false">
			<template #default>
				<div class="operate-record-content">
                    <div class="operate-record-content-header" :class="{ 'is-editor-page': isEditorPage }">
                        <div class="operate-record-content-header-title">{{ $t("operate_record_title") }}</div>
                        <div class="operate-record-content-header-close">
                            <i class="iconfont icon-icon_close" @click="closeDrawer"></i>
                        </div>
                    </div>
                    <div class="operate-record-content-empty" v-if="operateRecordList.length === 0">
                        <div class="operate-record-content-empty-text-icon">
                            <i class="iconfont icon-icon_blank_1" />
                        </div>
                        <div class="operate-record-content-empty-text-title">
                            {{ $t("operate_record_empty") }}
                        </div>
                    </div>
                    <div class="operate-record-content-list" v-if="operateRecordList.length > 0">
                        <div class="operate-record-content-list-item" v-for="(item,index) in operateRecordList" :key="item.id">
                            <div class="operate-record-content-list-item-content">
                                <!-- 成功 -->
                                <i class="iconfont icon-icon_check2" />
                                <!-- 失败 -->  
                                <!-- <i class="iconfont icon-icon_fail1" v-else></i> -->
                                <el-tooltip :content="item.origFileName" placement="top" :disabled="!isDesktop">
                                    <span :class="operateRecordMap[item.fileRecordId]?.isDestroy ? 'operate-record-content-list-item-title-disabled' : 'operate-record-content-list-item-title'"  
                                    v-if="item.operateType == 1" @click="handleItemClick(item)">
                                        {{ item.origFileName }}
                                    </span>
                                </el-tooltip>
                                <span class="operate-record-content-list-item-message">
                                    {{ operateTypeMap[item.operateType] }}
                                </span>
                            </div>
                            <div class="operate-record-content-list-item-date">
                                {{ formatDate(item.createTime, 'YYYY-MM-DD HH:mm:ss') }}
                            </div>
                        </div>
                    </div>
                    <div class="operate-record-content-list-tips">
                        <div class="operate-record-content-list-tips-icon">
                            <div class="tip-item-icon" />
                            <div class="tip-item-text">{{ $t("operate_record_tips1") }}</div>
                        </div>
                        <div class="operate-record-content-list-tips-icon">
                            <div class="tip-item-icon" />
                            <div class="tip-item-text">{{ $t("operate_record_tips2") }}</div>
                        </div>
                    </div>
                    <div class="operate-record-content-footer">
                        <div class="operate-record-content-footer-btn" v-if="operateRecordId" @click="handleBtnClick">
                            {{ $t("operate_record_btn") }}
                        </div>
                        <!-- <div class="operate-record-content-footer-btn-disabled" v-if="!operateRecordId">
                            {{ $t("operate_record_btn") }}
                        </div> -->
                    </div>
                </div>
			</template>

		</el-drawer>
    </div>
</template>

<script setup lang="ts">
import useBasicStore from '~/store/modules/basic'
import useSystemLaunageStore from '~/store/modules/systemLaunage'
import UniversalPopup from '~/components/Dialog/UniversalPopup/index.vue'
import UploadServer from '~/services/UploadServer'
import type { DrawerProps } from 'element-plus'
import { useRouter, useRoute } from 'vue-router'
import Toast from '~/utils/toast'
import eventBus from 'vue3-eventbus'
import { EventHomeMessage } from '~/config/event'

const viewport = useViewport()
const isDesktop = computed(() => viewport.breakpoint?.value.includes('desktop'))
const basicStore = useBasicStore()
const { isChina } = storeToRefs(basicStore)
const systemLanguageStore = useSystemLaunageStore()
const { systemLanguage } = storeToRefs(systemLanguageStore)
const { t, locale } = useI18n()
const localePath = useLocalePath()
const router = useRouter()
const route = useRoute()
const drawerSize  = computed(() => isDesktop.value ? '25%' : '100%')
const direction = ref<DrawerProps['direction']>('rtl')
const drawer = ref(false)

// 判断是否是 editor 页面
const isEditorPage = computed(() => {
    return route.path.includes('/editor')
})

const openDrawerFlag = ref(false);

watch(locale, (newVal) => {
    console.log(newVal, 'newVal')
    operateTypeMap.value = {
        1: t('operate_record_type_1'),
        2: t('operate_record_type_2'),
        3: t('operate_record_type_3'),
        4: t('operate_record_type_4')
    }
})

defineExpose({ operateRecordOpen, operateRecordClose })

const universalPopupRef = ref<InstanceType<typeof UniversalPopup>>()

// 销毁文件弹窗
const openUniversalPopup = () => {
    universalPopupRef.value?.open({
        title: t('popUp_title'),
        subTitle: t('operate_record_destroy_tips'),
        btn1: t('popUp_btn_cancel'),
        btn2: t('popUp_btn_confirm')
    })
}

// 销毁文件弹窗确认
const handleConfirm = () => {
    console.log('handleConfirm')
    if (!operateRecordId.value) {
        Toast(t('operate_record_destroy_tips'))
        return
    }
    UploadServer.getRecordDestroy({ fileRecordId: operateRecordId.value as number }).then((data)=>{
        if (data.code === '1') {
            Toast(t('operate_record_destroy_success'))
            operateRecordList.value = operateRecordList.value.filter((item: any) => item.fileRecordId !== operateRecordId.value)
            operateRecordId.value = null
            closeDrawer()
            // 跳转首页
            setTimeout(() => {
                router.push({ path: '/' })
            }, 1000)
        } else {
            Toast(data.message)
        }
    })
}

// operateType 1=上传完成;2=云端处理完成[保存修改成功];3=导出or下载;4=文件已销毁[已删除]
const operateRecordList = ref([])
const operateRecordId = ref<number | null>(null)
const operateRecordMap = ref<{ [key: number]: { isDestroy: boolean } }>({})

const operateTypeMap = ref({
    1: t('operate_record_type_1'),
    2: t('operate_record_type_2'),
    3: t('operate_record_type_3'),
    4: t('operate_record_type_4')
})

const handleBtnClick = (item: any)=>{
    console.log(item, 'item')
    openUniversalPopup()
}

const handleClose = (done: () => void) => {
	done()
}

function operateRecordOpen(recordId?: number) {
    console.log(recordId, 'recordId')
    operateRecordId.value = recordId || null
	openDrawer();
    getOperateRecordLogs()
}

function operateRecordClose() {
    closeDrawer();
}

function getOperateRecordLogs() {
    UploadServer.getOperateRecordLogs().then((data)=>{
        console.log("getOperateRecordLogs", data)
        if (data.code === '1') {
            data.list.forEach((item: any)=>{
                operateRecordMap.value[item.fileRecordId] = {isDestroy: item.operateType == 4}
            })
            operateRecordList.value = data.list
        }
    })
}

const handleItemClick = (item: any)=>{
    console.log('handleItemClick13333')
    if (operateRecordMap.value[item.fileRecordId] && operateRecordMap.value[item.fileRecordId].isDestroy) { 
        return
    }
    // 移动端关闭draw
    if (!isDesktop.value) {
        setTimeout(()=>{
            closeDrawer()
        }, 1000)
    }
    eventBus.emit(EventHomeMessage.changeFileName, item.origFileName)
    eventBus.emit(EventHomeMessage.uploadFileClick, { operateRecordItem: item, source: 'operateRecord'})
    // 告诉渲染弹窗文件名
    if (item.fileRecordId) {
        router.replace({
            path: `/${locale.value}/editor`, // 保持当前路径不变
            query: {
            ...route.query, // 展开现有所有 query 参数
            operateRecordId: item.fileRecordId, // 修改或新增目标参数
            },
        });
    }
    
    
   
    
}

const openDrawer = () => {
	drawer.value = true
	openDrawerFlag.value = true;
}
const closeDrawer = () => {
	drawer.value = false
	openDrawerFlag.value = false;
}

</script>

<style scoped lang="scss">
@use "./index.scss" as *;
@use "./mobile.scss" as *;
:deep(.desktop-el-drawer .el-drawer__body) {
  padding: 0 !important;
}
:deep(.mobile-el-drawer-operate-record .el-drawer__body) {
  padding: 0 !important;
}
</style>